module.exports = __webpack_public_path__ + "static/media/helen_wang.76cc4b0d.png";